(function($) {

var $doc = $(document),
	$win = $(window);

/* Site Navigation Toggle
   ========================================================================== */

$doc.on('click', '.navigation-toggle', function(e) {
	e.preventDefault();
	$(this)
		.toggleClass('navigation-toggle-active')
		.closest('.site-navigation')
			.find('.navigation-collapse').toggleClass('navigation-open');
});


/* Header Search Toggle
   ========================================================================== */

$doc.on('click', '.search-form-btn', function(e) {
	var state = $(this).data('clicked') || 0;
	if(state === 0){
		e.preventDefault();
		$('.search-form-input').toggleClass('active');
		$('.menu-site').toggleClass('active');
		// this will only happen the first time
		state++; // <-- we increment the state
		$(this).data('clicked', state);// <-- and store it back in data
		return; // <-- we stop the rest of the handler from running
   }
});

// Sticky Navigation
var sticky_position = $doc.scrollTop(),
	$siteHeader;

$doc.ready(function ($) {
	// Sticky header...
	$siteHeader = $('#masthead');

	$win.scroll(function (e) {
		// console.log(e);

		var old_pos = sticky_position,
			new_pos = $doc.scrollTop(),
			delta   = new_pos - old_pos;

		if (delta > 0 && new_pos >= 44 && !$siteHeader.is('.site-header-scroll')) {
			$siteHeader.addClass('site-header-scroll');
		} else if (delta < 0 && new_pos <= 64 && $siteHeader.is('.site-header-scroll')) {
			$siteHeader.removeClass('site-header-scroll');
		}

		sticky_position = new_pos;
	});

	$win.trigger('scroll');

	/* HTML5 Placeholder
	   ========================================================================== */

	$('input, textarea').placeholder();

	/* Slideshow Responsive
	   ========================================================================== */

	$win.on("load resize", function () {

		$('.slideshow-responsive').each( function() {
			$('.slideshow-responsive .slide').css('min-height', '0px');
			var slider = $(this),
				innerWrapper = slider.find('.slide'),
				largest = Math.max.apply(null, innerWrapper.filter(':not(.cycle-sentinel)').map(function () {
					return $(this).innerHeight();
				}).get());
			innerWrapper.css('min-height', largest + 'px');
		});

	}).resize();

	/* Table Responsive
	   ========================================================================== */

	$('table.table-responsive').each(function () {
		var self = $(this);
		if (!self.parent().is('.table-responsive-wrap'))
			self.addClass('table-responsive').wrap('<div class="table-responsive-wrap"></div>');
	});

	/* Tabbed
	   ========================================================================== */

	var tabbed = '.tabbed',
		tabItem = '.tab-item',
		tabLink = '.tab-link',
		tabLinkActive = '.tab-link-active',
		tabLinkActiveClass = 'tab-link-active',
		tab = '.tab',
		tabActiveClass = 'tab-active';

	$('.tabbed .tab-item:first-child .tab-link').addClass(tabLinkActiveClass);
	$(tab).hide();

	$(tabbed).each(function () {

		var component = $(this),
			activeHREF = component.find(tabLinkActive).attr('href');

		$(".tab-link[href='" +activeHREF+ "']").addClass(tabLinkActiveClass);
		$(component.find(tabLinkActive).attr('href')).show();

		component.find(tabLink).click( function (event) {
			var link      	= $(this),
				activeHREF	= $(this).attr('href'),
				wrapper		= link.closest(component),
				activeTab	= wrapper.find(tabLinkActive),
				windowWidth = $(window).width();

			$( activeTab.removeClass(tabLinkActiveClass).attr('href') ).hide().removeClass(tabActiveClass);
			$(".tab-link[href='" +activeHREF+ "']").addClass(tabLinkActiveClass);
			$( link.attr('href') ).show().addClass(tabActiveClass);

			// Anchor the window to the active tab on extra small and small screens.
			if (windowWidth < 768) {
				$('html, body').animate({scrollTop:$(this).offset().top}, 200);
			}

			event.preventDefault();
		});
	});

	/* Accordion
	   ========================================================================== */

	var accordion = '.accordion';
	var accordionHeader = '.accordion-header';
	var accordionContent = '.accordion-content';
	var accordionActive = 'accordion-active';

	$(accordion)
		.find(accordionContent).hide().end()
		.find(accordionHeader +':first').addClass(accordionActive).end()
		.find(accordionContent +':first').show().end()
		.on('click', accordionHeader, function (event) {
			var self = $(this);
			var accordionBody = self.closest(accordion);

			if (!self.hasClass(accordionActive)) {
				accordionBody
					.find(accordionHeader).removeClass(accordionActive).end()
					.find(accordionContent).slideUp();

				self.addClass(accordionActive)
					.next(accordionContent).slideDown();
			}

			event.preventDefault();
		});

	/* Match Height
	   ========================================================================== */

	// apply matchHeight to each item container's items
	$('.match-height').each(function() {
		$(this).find('.common-height').matchHeight();
	});

}); // end.ready

	/* Gallery Shortcode Fancybox
	   ========================================================================== */
	$(".gallery-thumbnail a").attr("rel","gallery");
	$(".gallery-thumbnail a").attr("class","gallery-fancybox");
	$(document).ready(function() {
		$(".gallery-fancybox").fancybox({
			maxWidth	: 800,
			maxHeight	: 600,
			fitToView	: false,
			width		: '70%',
			height		: '70%',
			autoSize	: false,
			closeClick	: false,
			openEffect	: 'none',
			closeEffect	: 'none'
		});

		$(".fancybox").fancybox();
	});

}(jQuery));